import { render, staticRenderFns } from "./productDesignHistory.vue?vue&type=template&id=a119644a&scoped=true"
import script from "./productDesignHistory.vue?vue&type=script&lang=js"
export * from "./productDesignHistory.vue?vue&type=script&lang=js"
import style0 from "./productDesignHistory.vue?vue&type=style&index=0&id=a119644a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a119644a",
  null
  
)

export default component.exports